// extracted by mini-css-extract-plugin
module.exports = {"image":"VR","loaded":"WR","placeholder":"XR"};